import Vue from 'vue';
import moment from 'moment';
import axios from 'axios';
import { v4 as uuidv4 } from 'uuid';

export default {
  name: 'Steps',
  components: {
    StepComp: require('./step.vue').default,
    EditableTable: require('../../../../customcontrols/editableTable.vue').default,
  },
  props: ['dataObj'],
  data: function () {
    return {
      appId: -1,
      steps: [],
      bStepDialog: false,
      bConfirmDialog: false,
      deleteConfirmMessage: '',
      editingStep: {
        elemenTypeName: '',
        elementName: '',
        stepId: 0,
      },
      editingStepClone: {
        elemenTypeName: '',
        elementName: '',
        stepId: 0,
      },
      message: '',
      tableCols: [],
      lookups: {},
      outcomes: []
    }
  },
  created() {
    //console.log("data steps", this.dataObj);
    this.$material.locale.dateFormat = 'dd/MM/yyyy';
    this.$root.$on('om_jobcard_updated', this.init);
    this.init();
    //console.log("steps data", this.dataObj);
  },
  methods: {
    async init() {
      Vue.nextTick(() => {
        this.dataObj.appData.steps.forEach(p => {
          if (!p.uuid || p.uuid.length === 0)
            p.uuid = uuidv4();
        });

        this.steps = this.dataObj.appData.steps;
      });
      
      await this.fillLookups();
      
      for (var i = 0; i < this.steps.length; i++) {
        this.steps[i].listSourceoutcomeId = this.lookups.outcomes[this.steps[i].outcomeTypeId];
        this.steps[i].allowEditserialNumber = this.steps[i].listSourceoutcomeId.filter(a => a.value == this.steps[i].outcomeId).length == 0 ? false : this.steps[i].listSourceoutcomeId.filter(a => a.value == this.steps[i].outcomeId)[0].hasSerial;
        this.steps[i].allowEditreading = this.steps[i].hasReading == null ? false : this.steps[i].hasReading;
        this.steps[i].allowEditreadingDt = this.steps[i].hasReading == null ? false : this.steps[i].hasReading;
        //this.steps[i].listSourceconditionId = this.steps[i].elementTypeId ? this.lookups.elementConditions[this.steps[i].elementTypeId] : this.lookups.elementConditions[0];
        await this.getElements(i, this.steps[i].elementTypeId);
      }
      this.fillTableCols();
    },
    async fillLookups() {
      this.lookups['outcomeTypes'] = this.dataObj.appData.outcomeTypes;
      this.lookups['outcomes'] = this.dataObj.appData.outcomeTypeToOutcomes;
      this.lookups['elementConditions'] = this.dataObj.appData.conditions;
      this.lookups['elementTypes'] = this.$store.state.elementTypesPlain;

      /*await axios.get('/Element/GetElementTypesPlain')
        .then(response => {
          if (response.status == 200) {
            this.lookups['elementTypes'] = response.data.items;
          }
          else
            this.$alertMsg(response.data.data.text)
        })
        .catch(errpr => {
          this.$alertMsg(errpr.response.data);
        });*/
    },
    addStep() {
      this.editingStepClone = {
        actualTime: 0,
        comment: '',
        conditionComment: '',
        conditionId: 0,
        conditionName: '',
        name: '',
        elemenTypeName: '',
        elementId: 0,
        elementName: '',
        elementTypeId: -1,
        outcomeId: 0,
        outcomeName: '',
        outcomeTypeId: 1,
        outcomeTypeName: '',
        hasReading: false,
        reading: null,
        readingDt: this.dataObj.appData.startDt,
        serialNumber: '',
        stepId: 0,
        //unit: null,
        //unitId: -1,
        uuid: uuidv4()
      };
      this.editingStepClone.unitTypes = this.unitTypes;
      this.editingStepClone.units = this.units;
      //this.bStepDialog = true;

      this.editingStepClone.listSourceoutcomeId = this.lookups.outcomes[this.editingStepClone.outcomeTypeId];
      this.editingStepClone.allowEditserialNumber = this.editingStepClone.listSourceoutcomeId.filter(a => a.value == this.editingStepClone.outcomeId).length == 0 ? false : this.editingStepClone.listSourceoutcomeId.filter(a => a.value == this.editingStepClone.outcomeId)[0].hasSerial;
      this.editingStepClone.allowEditreading = this.editingStepClone.hasReading == null ? false : this.editingStepClone.hasReading;
      this.editingStepClone.allowEditreadingDt = this.editingStepClone.hasReading == null ? false : this.editingStepClone.hasReading;

      this.editingStepClone.listSourceelementId = [];

      return this.editingStepClone;
    },
    editStep(item) {
      this.editingStep = item;
      this.editingStepClone = JSON.parse(JSON.stringify(item));
      this.editingStepClone.unitTypes = this.unitTypes;
      this.editingStepClone.units = this.units;
      this.bStepDialog = true;
    },
    removeConfirm(item) {
      this.deleteConfirmMessage = this.$t('omApplication.DeleteStep') + ' [' + item.stepId + '. ' + item.name + '] ?';
      this.editingStep = item;
      this.bConfirmDialog = true;
    },
    removeStep() {
      this.dataObj.appData.steps = this.dataObj.appData.steps.filter(p => p.uuid !== this.editingStep.uuid);
      this.steps = this.dataObj.appData.steps;
    },
    saveStep(item, index) {
      //error trap
      if (this.dataObj.appData.settings.checkStepPreviousReading == true &&
        moment(item.readingDt).isAfter(moment(item.prevReadingDt))) {
        this.$alertMsg(this.$t('messages.errorReadingDates'));
        return true;
      }
      

      //let idx = this.editingStepClone.outcomeId.indexOf('-');
      //this.editingStepClone.outcomeId = idx > -1 ? this.editingStepClone.outcomeId.substring(idx + 1, this.editingStepClone.outcomeId.length) : 0;
      //this.editingStepClone.outcomeId = parseInt(this.editingStepClone.outcomeId);
      //this.editingStepClone.actualTime = parseInt(this.editingStepClone.actualTime);
      //this.editingStepClone.reading = parseFloat(this.editingStepClone.reading);
      //this.dataObj.appData.steps = this.dataObj.appData.steps.filter(p => p.uuid !== this.editingStepClone.uuid);
      ////delete this.editingStepClone.unitTypes;
      ////delete this.editingStepClone.units;
      //this.dataObj.appData.steps.push(this.editingStepClone);
      //this.steps = this.dataObj.appData.steps;
      //this.bStepDialog = false;
    },
    closeDialog() {
      this.bStepDialog = false;
    },
    fillTableCols() {
      this.tableCols = [];

      this.tableCols.push({ label: this.$t('applications.Name'), property: 'name', allowEdit: true, dataType: 'string'});
      this.tableCols.push({ label: this.$t('readings.ActualTime'), property: 'actualTime', allowEdit: true, dataType: 'number'});


      if (this.$store.state.csAppsOfflineMode) {
        console.log(this.dataObj)
        const elements = [];

        elements.push({
          externalRef: null,
          id: this.dataObj.appData.elementId,
          name: this.dataObj.appData.elementRef,
          typeId: this.dataObj.appData.elementTypeId
        });

        this.tableCols.push({ label: this.$t('logs.ElementType'), property: 'elementTypeId', allowEdit: false, dataType: 'select', dataSource: this.lookups.elementTypes, displayField: 'name', valueField: 'typeId', displayModel: 'elemenTypeName' });
        this.tableCols.push({ label: this.$t('logs.Element'), property: 'elementId', allowEdit: false, dataType: 'select', dataSource: elements, displayField: 'name', valueField: 'id', displayModel: 'elementName' });
      } else {
        this.tableCols.push({ label: this.$t('logs.ElementType'), property: 'elementTypeId', allowEdit: true, dataType: 'select', dataSource: this.lookups.elementTypes, displayField: 'name', valueField: 'typeId', displayModel: 'elemenTypeName', changeFunc: this.elementTypeChange });
        this.tableCols.push({ label: this.$t('logs.Element'), property: 'elementId', allowEdit: true, dataType: 'select', displayField: 'name', valueField: 'id', displayModel: 'elementName', rowDataSource: true });
      }
      

      this.tableCols.push({ label: this.$t('activities.condition'), property: 'conditionId', dataType: 'select', dataSource: this.lookups.elementConditions, displayField: 'text', valueField: 'value', displayModel: 'conditionName' });
      this.tableCols.push({ label: this.$t('captureMR.ColumnSerialNo'), property: 'serialNumber', dataType: 'string', rowValidation: true});
      this.tableCols.push({ label: this.$t('customReadings.ReadingDateTime'), property: 'readingDt', dataType: 'date', rowValidation: true });
      if (this.dataObj.appData.settings.checkStepPreviousReading == true)
        this.tableCols.push({ label: this.$t('customReadings.prevReadingDateTime'), property: 'prevReadingDt', dataType: 'date' });
      this.tableCols.push({ label: this.$t('activities.reading'), property: 'reading', dataType: 'number', rowValidation: true });
      if (this.dataObj.appData.settings.checkStepPreviousReading == true)
        this.tableCols.push({ label: this.$t('customReadings.prevReading'), property: 'prevReading', dataType: 'number' });
      this.tableCols.push({ label: this.$t('logs.Unit'), property: 'unit', allowEdit: false});
      this.tableCols.push({ label: this.$t('readings.OutcomeType'), property: 'outcomeTypeId', allowEdit: true, dataType: 'select', dataSource: this.lookups.outcomeTypes, displayField: 'text', valueField: 'value', displayModel: 'outcomeTypeName', changeFunc: this.outcomeTypeChange });
      this.tableCols.push({ label: this.$t('readings.Outcome'), property: 'outcomeId', allowEdit: true, dataType: 'select', displayField: 'text', valueField: 'value', displayModel: 'outcomeName', rowDataSource: true, changeFunc: this.outcomeChange });
      this.tableCols.push({ label: this.$t('application.comment'), property: 'comment', allowEdit: true, dataType: 'multiString'});
      this.tableCols.push({ label: this.$t('assets.ConditionComments'), property: 'conditionComment', allowEdit: true, dataType: 'multiString' });

    },
    outcomeTypeChange(rowIdx, val) {
      this.steps[rowIdx].listSourceoutcomeId = this.lookups.outcomes[this.steps[rowIdx].outcomeTypeId];
      this.steps[rowIdx].outcomeId = this.steps[rowIdx].listSourceoutcomeId.length == 0 ? -1 : this.steps[rowIdx].listSourceoutcomeId[0].value;
      this.steps[rowIdx].allowEditserialNumber = this.steps[rowIdx].listSourceoutcomeId.filter(a => a.value == this.steps[rowIdx].outcomeId)[0].hasSerial;

      //this.steps[rowIdx].listSourceconditionId = this.steps[rowIdx].elementTypeId ? this.lookups.elementConditions[this.steps[rowIdx].elementTypeId] : this.lookups.elementConditions[0];

      this.$forceUpdate();

    },
    outcomeChange(rowIdx, val) {
      this.steps[rowIdx].allowEditserialNumber = this.steps[rowIdx].listSourceoutcomeId.filter(a => a.value == val)[0].hasSerial;
      this.$forceUpdate();
    },

    async getElements(rowIdx, typeId) {
      var parameter = {
        FilterByCurrentLocation: false,
        ElementTypeId: typeId,
        CoordLat: 0,
        CoordLong: 0,
        CoordAccuracy: 0
      };

      await axios.post('/Element/GetElements', parameter)
        .then(response => {
          if (response.status == 200) {
            this.steps[rowIdx].listSourceelementId = response.data.items;
            this.$forceUpdate();
          }
          else {
            this.$alertMsg(response.data.data.text);
            return [];
          }
        })
        .catch(e => {
          console.log(e);
          this.$alertMsg(e.message);
        });
    },
    async elementTypeChange(rowIdx, val) {
      await this.getElements(rowIdx, val);

      this.steps[rowIdx].elementId = this.steps[rowIdx].listSourceelementId.length == 0 ? -1 : this.steps[rowIdx].listSourceelementId[0].id;

      this.$forceUpdate();
    }
  },
  
}

